import styled from "@emotion/styled";
import { media } from "../../../components/Window/themes";
const Modal = {
    Wrapper: styled.div `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 700;
    width: 40%;
    outline: 0;
    ${media.medium} {
      width: 70%;
    }
  `,
    Backdrop: styled.div `
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 500;
  `,
    StyledModal: styled.div `
    z-index: 100;
    background-color: ${({ theme }) => theme.color.backgroundAside};
    position: relative;
    margin: auto;
    border-radius: 8px;
    color: ${({ theme }) => theme.color.text};
  `,
    Header: styled.div `
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    padding: 1rem;
  `,
    HeaderText: styled.div `
    align-self: center;
    font-weight: bold;
  `,
    CloseButton: styled.button `
    font-size: 0.8rem;
    color: ${({ theme }) => theme.color.text};
    border: none;
    border-radius: 3px;
    margin-left: 0.5rem;
    background: none;
    :hover {
      cursor: pointer;
    }
  `,
    Content: styled.div `
    max-height: 30rem;
    overflow-x: hidden;
    overflow-y: auto;
  `,
    ModalFooter: styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem;
    justify-content: end;
  `,
    RemoveButton: styled.button `
    cursor: pointer;
    color: ${({ theme }) => theme.color.deleteButtonColor};
    background-color: ${({ theme }) => theme.color.deleteButtonBgColor};
    border-color: ${({ theme }) => theme.color.danger};
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-inline-start: 0.5em;
    &:hover {
      background-color: #c70909;
      border-color: #c70909;
    }
    &:focus {
      box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 50%);
    }
    @media (max-width: 768px) {
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
    @media (min-width: 769px) and (max-width: 899px) {
      width: 100%;
    }
  `,
    CancelButton: styled.button `
    cursor: pointer;
    color: ${({ theme }) => theme.color.cancelButtonColor};
    background-color: ${({ theme }) => theme.color.cancelButtonBgColor};
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-inline-start: 0.5em;
    &:hover {
      background-color: ${({ theme }) => theme.color.cancelButtonHover};
      border-color: ${({ theme }) => theme.color.cancelButtonHover};
    }
    @media (max-width: 768px) {
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
    @media (min-width: 769px) and (max-width: 899px) {
      width: 100%;
    }
  `,
    InnerText: styled.p `
    padding: 1rem !important;
    border-top: 0.1rem solid lightgrey;
    border-bottom: 0.1rem solid lightgrey;
    margin: 0 !important;
  `,
};
export default Modal;
//# sourceMappingURL=Modal.styled.js.map